import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ExhibitionsService, ListData } from 'src/app/services/exhibitions/exhibitions.service';
import { LanguagesService } from 'src/app/services/languagesService/languages.service';
import * as moment from "moment";

const STATE_ACTIVATED = {
  progress: "in-progress",
  accepted: "accepted",
  rejected: "rejected"
}

@Component({
  selector: 'app-exhibitions',
  templateUrl: './exhibitions.page.html',
  styleUrls: ['./exhibitions.page.scss'],
})
export class ExhibitionsPage implements OnInit {

  @ViewChild("DateStartInp") DateStartInp: HTMLInputElement;
  @ViewChild("DateEndInp") DateEndInp: HTMLInputElement;

  ListResult = { status: '', items: [] as ListData, error: null }
  list = { status: '', items: [] as ListData, error: null }
  data
  storeName = [];
  stateActivated = STATE_ACTIVATED.progress
  states = STATE_ACTIVATED
  datesFilter = {
    start: null,
    end: null,
  }

  public config = {
    imageField: 'image',
    fields: [
      { label: 'Identificador: ', key: 'id' },
      { label: 'Email: ', key: 'email' },
      { label: 'Cantidad: ', key: 'total' },
    ],
  };

  constructor(
    private router: Router,
    public languageService: LanguagesService,
    private exhibitionService: ExhibitionsService
  ) { }

  ngOnInit() {
    this.getData();
  }

  ionViewDidEnter() {
    this.resetDates();
    // this.stateActivated = STATE_ACTIVATED.progress;
    this.filterState(this.stateActivated)
  }

  public viewMore(id) {
    this.router.navigate(['app/exhibitions', 'detail', id]);
  }

  get getTextsIUPageExhibitions() {
    return this.languageService.textsIU.page_exhibitions;
  }

  getData() {
    this.exhibitionService.getExhibitions().then((data) => {
      data.subscribe((data) => {
        this.ListResult = { status: '', items: data as ListData, error: null }
        this.data = this.ListResult
        const dataSort = data ? this.data.items.sort((a, b) => ((b["createAt"].toMillis()) - (a["createAt"].toMillis()))) : [];
        this.list.items = dataSort.filter((item) => {
          item.image = (/\.(jpg|png|gif|svg|jpeg)/i).test(item.photos[0].value) ? item.photos[0].value : '../../assets/icons/icon_exhibition.svg';
          if (item.status == this.stateActivated) {
            return true
          }
        })
      });
    })
  }

  add() {
    this.router.navigate(['app/exhibitions/form']);
  }

  filterState(state) {
    this.resetDates();
    this.stateActivated = state
    this.list.items = this.data.items.filter((item) => {
      if (item.status == this.stateActivated) {
        return true
      }
    })
  }

  async filterDate($event, position) {
    this.datesFilter[position] = $event.target.value
    if (this.datesFilter.start) {
      const ItemSort = this.data ? this.data.items.sort((a, b) => ((b["createAt"].toMillis()) - (a["createAt"].toMillis()))) : [];
      this.list.items = await ItemSort.filter((data) => {
        const dateDocument = moment((data["createAt"].toMillis())).format("YYYY-MM-DD")
        const dateEnd = this.datesFilter.end ? this.datesFilter.end : moment().format("YYYY-MM-DD")
        if (dateDocument >= this.datesFilter.start && dateDocument <= dateEnd) {
          if (this.stateActivated != this.states.progress) {
            if (this.stateActivated == this.states.accepted) {
              if (data.status == this.states.accepted) {
                return true;
              }
            } else {
              if (data.status == this.states.rejected) {
                return true;
              }
            }
          } else {
            if (data.status == this.states.progress) {
              return true;
            }
          }
        }
      })
    }
  }

  resetDates() {
    let datesFilterStart = (document.getElementById("datesFilterStart") as HTMLInputElement)
    datesFilterStart.value = "";
    let datesFilterEnd = (document.getElementById("datesFilterEnd") as HTMLInputElement)
    datesFilterEnd.value = "";
  }
}
